import { Injectable } from '@angular/core';
import { Lesson } from '.';
import { School } from '../school';
import { Student } from '../student';

@Injectable()
export class LessonUtilService {
    public static readonly DEFAULT_BACKGROUND_COLOR = '9a8e8a';
    public static readonly LESSON_BEGINING_FIELD_NAME = 'begining';
    public static readonly CARD_ENDING_FIELD_NAME = 'validUntil';

    public static getBackgroundColor(lesson: Lesson): string {
        return '#' +
            (lesson.classType && lesson.classType.backgroundColor ?
            lesson.classType.backgroundColor : LessonUtilService.DEFAULT_BACKGROUND_COLOR);
    }

    public static allowToPayOnline(school: School, lesson: Lesson, student: Student) {
        // It does not make sense to allow to pay online an student that does not belong to the given school
        if ((!school || !lesson || !student) ||
            (school.id !== student.schoolId) ||
            (!school.acceptOnlinePayments || !school.onlinePaymentsModuleEnabled) ||
            (!student.acceptOnlinePayments) ||
            (!lesson.classType || !lesson.classType.backOfficeUnitPriceId)
            ) {
            return false;
        }
        return true;
    }

    public static allowCurrentStudentToBook(currentUserIsStudent: boolean, lesson: Lesson) {
        return currentUserIsStudent && (lesson.currentStudentCard || lesson.free);
    }

    public static allowCurrentStudentToCheckout(currentUserIsStudent: boolean, lesson: Lesson) {
        return currentUserIsStudent && !lesson.currentStudentCard && !lesson.free;
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/lesson/lesson.util.service.ts